import { Typography } from "@mui/material";
import React from "react";

export default function IDComponent({ id }) {
  return (
    <Typography sx={{ float: "right", pt: 1.5, color: "#888" }}>
      ID: {id}
    </Typography>
  );
}
